  import baharPic from "../Assets/mine.jpg";

export const profile = {
  name: "Masum Al Reza",
  image: baharPic,
  titles: [
    "Mobile App Developer",
    "Flutter & Android Specialist",
    "Laravel Backend Developer",
    "Full Stack Engineer",
  ],
  bio: [
    "I am Masum Al Reza, a passionate Mobile App Developer with expertise in Flutter, Android, and Laravel. I build robust, scalable, and user-friendly applications for both mobile and web platforms.",
    "With several years of experience, I have delivered multiple successful projects and thrive on solving complex problems with elegant solutions.",
  ],
  social: {
    email: "object.masum@gmail.com",
    linkedin: "https://www.linkedin.com/in/masum-al-reza/",
    github: "https://github.com/massumm",
    x: "https://twitter.com/massumm",
  },
};
